import { pull } from 'lodash';

export type EventHandler<E = any> = (e: E) => void;

/* 这个就是事件的原型*/
class EventEmitter<E = any> {
  private events: Record<string, EventHandler<E>[]>;

  constructor() {
    this.events = {};
  }

  public on<T = E>(event: string, cb: EventHandler<T>) {
    const fns = this.getFns(event);
    fns.push(cb as any);
  }

  public off(event: string, cb?: EventHandler<E>) {
    if (cb) {
      const fns = this.getFns(event);
      pull(fns, cb);
    } else {
      delete this.events[event];
    }
  }

  public once<T = E>(event: string, cb: EventHandler<T>) {
    const fn2: EventHandler<E> = (e) => {
      this.off(event, fn2);
      cb(e as any);
    };
    this.on(event, fn2);
  }

  /* 同步调用 */
  public emit<T = E>(event: string, param?: T) {
    const fns = this.getFns(event);
    fns.forEach((fn: EventHandler<any>) => {
      fn(param);
    });
  }

  /* 可以异步调用，返回一个Promise */
  public invoke<T = E>(event: string, param?: T): Promise<any> {
    const fns: EventHandler<any>[] = this.getFns(event);

    for (const fn of fns) {
      fn(param);
      return new Promise<any>((resolve) => {
        resolve(fn(param));
      });
    }
    return Promise.reject();
  }

  private getFns(event: string) {
    return this.events[event] || (this.events[event] = []);
  }
}

export default EventEmitter;
